const HOME_PAGE_CONTRACTOR_HOMEOWNER_MESSAGE = [
  {
    id: 1,
    contractorMessage:
      'We can boost curb appeal within budget. I have some ideas... ',
    homeOwnerMessage: 'I’m listening.',
  },
  {
    id: 2,
    contractorMessage: 'What if we updated the siding to be more modern?',
    homeOwnerMessage: 'I don’t know - how will it look?',
  },
  {
    id: 3,
    contractorMessage:
      'Ever thought about a metal roof? It’s great for heating bills.',
    homeOwnerMessage: 'Let’s try it!',
  },
  {
    id: 4,
    contractorMessage:
      'New windows can build a look that’s modern and traditional.',
    homeOwnerMessage: 'Great.',
  },
  {
    id: 5,
    contractorMessage: 'You can’t forget the doors...',
    homeOwnerMessage: 'Wow. All within budget? I’m sold!',
  },
];

export default HOME_PAGE_CONTRACTOR_HOMEOWNER_MESSAGE;
